import { Link } from "react-router-dom";
import { useReveal } from "../lib/useReveal";
import { Users, HeartHandshake, HandCoins, Newspaper } from "lucide-react";

const WAYS = [
  {
    icon: HandCoins,
    title: "Donate",
    body: "₹950 / $10 a month or a one-time gift — funds go straight to adopted schools with quarterly transparency reports.",
    cta: "Give now",
    href: "/get-involved#donate",
    testid: "involve-donate",
  },
  {
    icon: Users,
    title: "Volunteer",
    body: "Field visits, teaching support, translation, design, storytelling — join the circle in whichever way fits your life.",
    cta: "Sign up",
    href: "/get-involved#volunteer",
    testid: "involve-volunteer",
  },
  {
    icon: HeartHandshake,
    title: "Institutional Partnership",
    body: "Schools, corporates and trusts partner with us on named school adoption, ETM labs and hygiene programmes.",
    cta: "Talk to us",
    href: "/contact",
    testid: "involve-partner",
  },
  {
    icon: Newspaper,
    title: "Amplify our voice",
    body: "Share our stories, tag us in your network, write about the work. Awareness is oxygen for a small NGO.",
    cta: "Follow",
    href: "/news#media",
    testid: "involve-amplify",
  },
];

export default function GetInvolved() {
  const ref = useReveal();

  return (
    <section id="get-involved" data-testid="get-involved-section" className="relative py-16 md:py-28 bg-parchment-light">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div ref={ref} className="reveal max-w-3xl text-center md:text-left">
          <span className="section-chip">Get Involved</span>
          <h2 className="mt-3 font-display font-extrabold text-navy text-3xl sm:text-4xl md:text-5xl leading-[1.1] tracking-tight">
            Four ways to <em>Stand With Us.</em>
          </h2>
        </div>

        <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {WAYS.map((w) => {
            const Icon = w.icon;
            return (
              <Link
                key={w.title}
                data-testid={w.testid}
                to={w.href}
                className="manuscript-card group hover:-translate-y-1 transition-transform block"
              >
                <div className="w-12 h-12 rounded-full bg-teal/10 text-teal flex items-center justify-center border-2 border-dashed border-teal/40">
                  <Icon className="w-6 h-6" />
                </div>
                <h3 className="mt-4 font-display font-bold text-navy text-xl leading-snug">{w.title}</h3>
                <p className="mt-2 text-indigo/75 font-display text-sm leading-relaxed">{w.body}</p>
                <div className="mt-5 flex items-center gap-2 text-vermilion text-xs uppercase tracking-widest font-display font-semibold">
                  {w.cta}
                  <span className="w-8 h-[1.5px] bg-vermilion group-hover:w-12 transition-all" />
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}
